import React, {Component} from "react";
import {
    Table as BootstrapTable,
    Row,
    Col
}                         from "react-bootstrap";
import moment             from "moment";

import { IS_VALID }        from "utils";

export default class View extends Component {
    constructor (props) {
        super(props);

        this.state = {
            isLoadingRelation: false,
            cardType: []
        };

        this.getRelation = this.getRelation.bind(this);
    }

    getRelation () {
        let {
            selectedData,

            getRelation
        } = this.props;

        if (
            IS_VALID(selectedData)
        ) {
            this.setState({ isLoadingRelation: true });

            getRelation()
            .then((cardTypes) => {
                this.setState({
                    isLoadingRelation: false,
                    cardType: cardTypes.map((item) => item.get("name"))
                });
            })
            .catch((err) => {
                console.log("getRelation error");
                console.log(err);

                this.setState({ isLoadingRelation: false });
            });
        }
    }

    render () {
        let {
            isLoadingRelation,
            cardType
        } = this.state;

        let {
            selectedData
        } = this.props;

        const GET_VALUE = (key) => {
            if (
                IS_VALID(selectedData) &&
                IS_VALID(selectedData.get(key))
            ) {
                let value = "";

                if (
                    key === "createdAt" ||
                    key === "updatedAt"
                ) {
                    value = moment(selectedData.get(key)).format("MMM-DD-YYYY");
                } else if (
                    key === "createdBy" ||
                    key === "updatedBy"
                ) {
                if (IS_VALID(selectedData.get(key))) {
                    value = selectedData.get(key).get("name") || "";
                }
                } else {
                    value = selectedData.get(key);
                }

                return value;
            } else {
                return "";
            }
        }
        return (
            <BootstrapTable
                bordered
                responsive
            >
                <tbody>
                    <tr>
                        <td>
                        <b>Name</b>
                        </td>
                        <td>{GET_VALUE("name")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Card Type</b>
                        </td>
                        <td>
                            {isLoadingRelation ? (
                                <i className="fa fa-spinner fa-spin"></i>
                            ) : (
                                cardType.join(", ")
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <b>Message</b>
                        </td>
                        <td>
                            <p style={{ whiteSpace: "pre-wrap"}}>{GET_VALUE("message")}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <b>Created At</b>
                        </td>
                        <td>{GET_VALUE("createdAt")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Updated At</b>
                        </td>
                        <td>{GET_VALUE("updatedAt")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Created By</b>
                        </td>
                        <td>{GET_VALUE("createdBy")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Updated By</b>
                        </td>
                        <td>{GET_VALUE("updatedBy")}</td>
                    </tr>
                </tbody>
            </BootstrapTable>
        );
    }

    componentDidMount () {
        this.getRelation();
    }
}


// WEBPACK FOOTER //
// ./components/CustomBlockMessage/FormContainer/View.js